module.exports = __webpack_public_path__ + "assets/32b003b67b166ede76aa6b38361cbe17.png";